import { analytics } from "../config";
import { logEvent } from "firebase/analytics";

/**
 * Filtra bots e rastreadores automáticos para manter os dados limpos.
 */
const isBot = () => {
  if (typeof navigator === "undefined") return true;
  return /bot|googlebot|crawler|spider|robot|crawling|headless/i.test(
    navigator.userAgent,
  );
};

export const trackEvent = (eventName: string, params?: object) => {
  if (analytics && !isBot()) {
    logEvent(analytics, eventName, params);
  }
};

export const AnalyticsMetrics = {
  // Rastreio de Visualização de Página (Filtrado para bots)
  trackPageView: (path: string) => {
    trackEvent("page_view", {
      titulo_metrica: "Visualização de Página",
      page_path: path,
    });
  },

  // Rastreio de Login Confirmado (Métrica chave de sucesso)
  trackUserLoggedIn: (userId: string, method: string) => {
    trackEvent("user_login_confirmed", {
      titulo_metrica: "Usuário Logado com Sucesso",
      user_id: userId,
      method: method,
      status: "logged_in",
    });
  },

  // Rastreio de Sucesso no Cadastro
  trackRegisterSuccess: (userId?: string) => {
    trackEvent("sign_up", {
      titulo_metrica: "Sucesso no Cadastro",
      method: "email",
      user_id: userId,
    });
  },

  // Rastreio de Erros
  trackError: (errorType: string, errorMessage: string) => {
    trackEvent("exception", {
      titulo_metrica: "Rastreio de Erros",
      description: `${errorType}: ${errorMessage}`,
      fatal: false,
    });
  },

  // Rastreio de Abandono
  trackSignupAbandonment: (stepName: string) => {
    trackEvent("signup_abandonment", {
      titulo_metrica: "Abandono de Cadastro",
      etapa: stepName,
      descricao: `Parou na etapa: ${stepName}`,
    });
  },

  // Métrica de Localização (Se necessário para o seu nicho)
  trackRealLocation: (lat: number, lng: number) => {
    trackEvent("real_location_update", {
      titulo_metrica: "Localização GPS",
      latitude: lat,
      longitude: lng,
    });
  },
};
